
import React, { useEffect, useState } from 'react'
import MainLayout from '../../layouts/MainLayout/MainLayout';
import './Subscription.css'
import PricingCard from '../../features/Subscription/PricingCard/PricingCard';
import { Loader, SimpleGrid, Stack } from '@mantine/core';
import axios from 'axios';
import showNotification from '../../utils/showNotification';
import { Helmet } from "react-helmet"; 


export default function Subscription() {

   const [subscriptions, setSubscriptions] = useState(null)
   const [isLoading, setIsLoading] = useState(false)

   useEffect(() => {
      const getSubscriptions = async () => {
         try {
            setIsLoading(true)
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/subscriptions`)
            setSubscriptions(data)
         } catch (error) {
            console.log(error)
            showNotification({
               color: "red",
               status: "error",
               title: "Error",
               message: `Error al cargar los planes de suscripción: ${error}`,
            });
         } finally {
            setIsLoading(false)
         }
      }
      getSubscriptions()
   }, [])


   return (
      <>
         <Helmet>
            <title>FORVET | Suscripciones</title>
            <meta name="description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
            <meta property="og:title" content="FORVET | Suscripciones" />
            <meta property="og:description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
         </Helmet>
         <MainLayout>
            <div className="SubscriptionPage-main-container">
               <h1 className="landingHero__title">
                  Potenciá tu carrera veterinaria <br />
                  <span className="landingHero__gradient">
                     planes de suscripción
                  </span>
               </h1>
               <Stack mb={20}>
                  <p className='SubscriptionPage--description'>
                     Formá parte de una comunidad que apuesta al <strong>crecimiento constante</strong>, la <strong>actualización profesional</strong> y el intercambio con colegas apasionados <strong>como vos</strong>.
                  </p>
                  <p className='SubscriptionPage--description'>
                     Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá.
                  </p>
               </Stack>
               {isLoading
                  ? <div style={{ height: '100%', width: '100%', display: 'grid', placeItems: "center" }}>
                     <Loader />
                  </div>
                  : <Stack align='start' p={0} gap={40}>
                     <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing={{ base: "xl", sm: "md", md: "xl" }}>
                        {(subscriptions && subscriptions?.length > 0) && subscriptions?.map(item => (
                           <PricingCard content={item} />
                        ))
                        }
                     </SimpleGrid>
                     {/* <SubscriptionsTable content={subscriptions} /> */}
                  </Stack>
               }
            </div>
         </MainLayout>
      </>
   )
}
